var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEyeTemplate = function SvgIconEyeTemplate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#505665",
    d: "M10 13.608A3.61 3.61 0 0 1 6.392 10 3.61 3.61 0 0 1 10 6.392 3.61 3.61 0 0 1 13.608 10 3.61 3.61 0 0 1 10 13.608m0-5.966A2.36 2.36 0 0 0 7.642 10c0 1.3 1.058 2.358 2.358 2.358S12.358 11.3 12.358 10 11.3 7.642 10 7.642"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#505665",
    d: "M10 17.517c-3.133 0-6.092-1.834-8.125-5.017-.883-1.375-.883-3.617 0-5 2.042-3.183 5-5.017 8.125-5.017s6.083 1.834 8.117 5.017c.883 1.375.883 3.617 0 5-2.034 3.183-4.992 5.017-8.117 5.017m0-13.784c-2.692 0-5.267 1.617-7.067 4.442-.625.975-.625 2.675 0 3.65 1.8 2.825 4.375 4.442 7.067 4.442s5.267-1.617 7.067-4.442c.625-.975.625-2.675 0-3.65-1.8-2.825-4.375-4.442-7.067-4.442"
  })));
};
export default SvgIconEyeTemplate;